import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { Button, Select, Table } from "@ds/ds-snam/react";
import ConfirmPopUp from "components/ConfirmPopUp";
import NoDataFound from "components/NoDataFound";
import { IContractBookSlot } from "dataModels/b2b";
import { set } from "lodash";
import {  getConguaglioAPI, postConguaglioAPI} from "net/prebilling";

import { getBusinessSettle, getContractsSettle } from "net/b2b";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { EntityType } from "shared/constants";
import { dsDeselectHandler, dsSelectHandler, getDSTableShaderElementsForFilterColumn, getDSTableSharedElements, getTableCellsHeaderSimple } from "shared/utils/dsComponentUtils";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";

interface ISettlePriceAdjustmentItems {
    id: number;
    contractId: number;
    contractCode: string;
    cost: number;
    insertDate: string;
    insertUser: string;
}
interface ISettleData {
    "contractPriceAdjustmentItems": ISettlePriceAdjustmentItems[] ,
    "adjustment": number
}

const Conguaglio:React.FC<{}> = ():JSX.Element=>{

    const { t, i18n } = useTranslation(["preBilling", "app","b2b","dashboard"]);
    const dispatch = useDispatch();
    const [settleData, setSettleData] = useState<ISettleData | undefined>();
    const [businessesList, setBusinessesList] = useState<ISelectLabel[] | undefined>();
    const [selectedBusiness, setSelectedBusiness] = useState<string | undefined>();
    const [contractsList, setContractsList] = useState<ISelectLabel[] | undefined>();
    const [selectedContract, setSelectedContract] = useState<string | undefined>();
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const [selectResetKey, setSelectResetKey] = useState(0);
    

    

    const loadContracts = () => {
        if(selectedBusiness!==undefined){
            dispatch(requestPending());
            getContractsSettle(selectedBusiness)
                .then((response: any) => {
                    /*let mock = [
                        {
                            "id": "26",
                            "label": "Contract prova sprint3 1",
                            "value": "26"
                        }
                    ]
                    setContractsList(mock);*/
                    setContractsList(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    return dispatch(requestPristine());
                })
        }
        
    };

    useEffect(() => {
        setSettleData(undefined);
        if(contractsList!==undefined){
            setSelectedContract(undefined);
            dsDeselectHandler(contractsList);
        }
        if(selectedBusiness!==undefined){
            loadContracts();        
        }
    }, [selectedBusiness]);


    const loadBusinesses = () => {
        dispatch(requestPending());
        getBusinessSettle()
            .then((response: any) => {
                /*let mock = [
                    {
                        "id": "21",
                        "label": "Cliente11",
                        "value": "21"
                    }
                ];
                setBusinessesList(mock);*/
                setBusinessesList(response);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                return dispatch(requestPristine());
            })
    };

    useEffect(() => {
        loadBusinesses()
    }, []);

    useEffect(()=>{
        if(selectedContract!==undefined){
            dispatch(requestPending());
            getConguaglioAPI(selectedContract)
            .then((response: any) => {
               setSettleData(response);
            })
            .catch(error => {
                /*setSettleData(
                    {
                        "contractPriceAdjustmentItems": [
                            { "id": 1, "contractId": 12, "contractCode": "contratto1", "cost": 12.34, "insertDate": "9999-12-31T23:59:59.9999999", "insertUser": "Mionome Miocognome" },
                            { "id": 2, "contractId": 12, "contractCode": "contratto2", "cost": 12.34, "insertDate": "0001-01-01T00:00:00", "insertUser": "Mionome Miocognome" },
                        ],
                        "adjustment": 23.4566
                    }
                )*/
                console.log(error);
            })
            .finally(() => {
                return dispatch(requestPristine());
            })
        }
    },[selectedContract])

    const getTableRowsSettle = (): ITableRow[] => {
                let myRetArr: ITableRow[] = [];
                settleData?.contractPriceAdjustmentItems.forEach((item) => {
                    let tempObj: ITableRow = {
                        tableCells: [
                            { 
                                type: "text", 
                                text: item.cost.toString(),
                            },
                            { 
                                type: "text", 
                                text: item.insertDate,
                            },
                            { 
                                type: "text", 
                                text: item.insertUser,
                            }
                        ],
                    };
                    myRetArr.push(tempObj);
                });
                return myRetArr;
    };

    const myTableConfigSettle: ITableConfig = {
        ...getDSTableSharedElements(560),
        tableHeader: {
            tableCellsHeader: [
                getTableCellsHeaderSimple(t('preBilling.conguaglio.tables.0') as string,"col10","34%","left"),
                getTableCellsHeaderSimple(t('preBilling.conguaglio.tables.1') as string,"col11","33%","left"),
                getTableCellsHeaderSimple(t('preBilling.conguaglio.tables.2') as string,"col12","33%","left"),
            ]
        },
        tableRows: getTableRowsSettle()
    };

    const confirmSettlement = () => {
        dispatch(requestPending());
            postConguaglioAPI(selectedContract!, settleData!.adjustment)
            .then((response: any) => {
                setSettleData(undefined);
                if(contractsList!==undefined){
                    setSelectedContract(undefined);
                    dsDeselectHandler(contractsList);
                    setContractsList(undefined);
                }
                if(businessesList!==undefined){
                    setSelectedBusiness(undefined);
                    dsDeselectHandler(businessesList);
                }
                setSelectResetKey((key) => key + 1);
            })
            .catch(error => {
                /*setSettleData(undefined);
                if(contractsList!==undefined){
                    setSelectedContract(undefined);
                    dsDeselectHandler(contractsList);
                    setContractsList(undefined);
                }
                if(businessesList!==undefined){
                    setSelectedBusiness(undefined);
                    dsDeselectHandler(businessesList);
                }
                setSelectResetKey((key) => key + 1);*/
                console.log(error)
            })
            .finally(() => {
                return dispatch(requestPristine());
            })
    }

    return (
        <>
            <Row>
                <Col>
                    <p className="pageTitle">
                        {t('preBilling.conguaglio.titles.0')} {/*Conguaglio*/}
                    </p>
                </Col>
            </Row>
            <Row style={{marginTop:'30px'}}>
                <Col xs={12} md={3}>
                    <Select
                        key={`business-selection-${selectResetKey}`}
                        id="businessSelection"
                        menuPlaceholder=""
                        hasIcon={false}
                        menuOptions={businessesList === undefined ? [] : businessesList}
                        menuLabel={t("dashboard.labels.0",{ns:'dashboard'})}
                        menuId="select-business"
                        isDisabled={businessesList === undefined}
                        selectStatus="default"
                        onOptionSelection={(event: Event) => {
                            const business = (event as CustomEvent).detail.option;
                            const businessSelected = (event as CustomEvent).detail.option.value
                            dsSelectHandler(businessesList as ISelectLabel[], business);
                            setSelectedBusiness(businessSelected);
                        }}
                    ></Select>
                </Col>
                <Col xs={12} md={3}>
                    <Select
                        key={`contract-selection-${selectResetKey}`}
                        id="contactSelection"
                        menuPlaceholder=""
                        hasIcon={false}
                        menuOptions={contractsList === undefined ? [] : contractsList}
                        menuLabel={t("dashboard.labels.1",{ns:'dashboard'})}
                        menuId="select-contract"
                        isDisabled={contractsList === undefined}
                        selectStatus="default"
                        onOptionSelection={(event: Event) => {
                            const contract = (event as CustomEvent).detail.option;
                            const contractSelected = (event as CustomEvent).detail.option.value
                            dsSelectHandler(contractsList as ISelectLabel[], contract);
                            setSelectedContract(contractSelected);
                        }}
                    ></Select>
                </Col>
            </Row>
            {settleData !== undefined && (
                <Row style={{marginTop:'25px',marginBottom:'25px'}}>
                    <Col>
                        <p className="formSubTitle">{t('preBilling.conguaglio.subtitles.0') as string}: {settleData.adjustment}</p>
                        <Button 
                            style={{float:'left',marginTop:'20px'}}
                            buttonUIVariant="primary"
                            buttonSize="medium"
                            buttonLabel={t('preBilling.conguaglio.subtitles.1')}
                            isDisabled={false}
                            onClickEvent={() => {
                                setShowConfirm(true);
                            }}
                        ></Button>
                    </Col>
                </Row>
            )}
            <>
                        
                { settleData!==undefined ?
                    <>
                    {settleData.contractPriceAdjustmentItems.length!==0 ? 
                     <Table 
                        tableConfig={myTableConfigSettle} 
                        style={{}}       
                    />
                    :
                    <>{t('preBilling.conguaglio.subtitles.4')}</>

                    }
                    </>                   
                :
                    <div style={{marginTop:'25px'}}><NoDataFound
                        title={t('preBilling.preBillingView.titles.4')}
                        subTitle={t('preBilling.preBillingView.titles.5')}
                    /></div>
                }
            </>

            {showConfirm && (
                <ConfirmPopUp
                    title={t('preBilling.conguaglio.subtitles.2')} 
                    description={t('preBilling.conguaglio.subtitles.3')}
                    onClose={() => {
                        setShowConfirm(false);
                    }}
                    onConfirm={() => {
                        setShowConfirm(false);
                        confirmSettlement();
                    }}
                />
            )}
        </>
    );
}
export default Conguaglio;
